import { PLAN_REVIEW_QUALITY_GROUP_KEYS } from '../config/justification'
import {
  IPlanReviewJustificationParams,
  PlanReviewSection,
  TPlanReviewOffering,
  TPlanReviewQualityGroupKey,
} from '../model/types'

const FINANCIAL_SECTIONS = new Set<PlanReviewSection>([
  PlanReviewSection.FinancialGrowth,
  PlanReviewSection.SobGrowth,
])

export const getPlanReviewQualityGroupKey = (
  section: PlanReviewSection
): TPlanReviewQualityGroupKey =>
  section === PlanReviewSection.Summary
    ? PLAN_REVIEW_QUALITY_GROUP_KEYS.summary
    : section === PlanReviewSection.PlanningMeasure
      ? PLAN_REVIEW_QUALITY_GROUP_KEYS.planningMeasure
      : FINANCIAL_SECTIONS.has(section)
        ? PLAN_REVIEW_QUALITY_GROUP_KEYS.financial
        : PLAN_REVIEW_QUALITY_GROUP_KEYS.initiatives

export const buildPlanReviewJustificationParams = ({
  section,
  fYear,
  programType,
  isGlobal,
  userEmail,
  userFullName,
}: {
  section: PlanReviewSection
  fYear: number
  programType: TPlanReviewOffering
  isGlobal: boolean
  userEmail: string
  userFullName: string
}): IPlanReviewJustificationParams => ({
  PlanQualityGroupKey: getPlanReviewQualityGroupKey(section),
  PlanQualitySectionKey: section,
  FYear: fYear,
  ProgramType: programType,
  IsGlobal: isGlobal,
  UserEmail: userEmail,
  UserFullName: userFullName,
})
